import "react-native-gesture-handler";
import App from "./src/components/App/App.container";

export default App;
